module.exports = __webpack_public_path__ + "static/media/SCC_logo_NEW.946ed193.png";